/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Cookies_TextInputs */

const en_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use the following types of cookies and local storage:`)
};

const de_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden folgende Arten von Cookies und lokalem Speicher:`)
};

const fr_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons les types suivants de cookies et de stockage local :`)
};

const es_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizamos los siguientes tipos de cookies y almacenamiento local:`)
};

const it_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizziamo i seguenti tipi di cookie e archiviazione locale:`)
};

const nl_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wij gebruiken de volgende soorten cookies en lokale opslag:`)
};

const pl_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Używamy następujących rodzajów ciasteczek i magazynu lokalnego:`)
};

const fi_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytämme seuraavan tyyppisiä evästeitä ja paikallista tallennusta:`)
};

const da_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bruger følgende typer cookies og lokal lagring:`)
};

const sv_privacy_cookies_text = /** @type {(inputs: Privacy_Cookies_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi använder följande typer av cookies och lokal lagring:`)
};

/**
* | output |
* | --- |
* | "We use the following types of cookies and local storage:" |
*
* @param {Privacy_Cookies_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_cookies_text = /** @type {((inputs?: Privacy_Cookies_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Cookies_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_cookies_text(inputs)
	if (locale === "fr") return fr_privacy_cookies_text(inputs)
	if (locale === "es") return es_privacy_cookies_text(inputs)
	if (locale === "it") return it_privacy_cookies_text(inputs)
	if (locale === "nl") return nl_privacy_cookies_text(inputs)
	if (locale === "pl") return pl_privacy_cookies_text(inputs)
	if (locale === "fi") return fi_privacy_cookies_text(inputs)
	if (locale === "da") return da_privacy_cookies_text(inputs)
	if (locale === "sv") return sv_privacy_cookies_text(inputs)
	return en_privacy_cookies_text(inputs)
});